// extracted by mini-css-extract-plugin
module.exports = {"tabContainer":"style_tabContainer__munQM","item":"style_item__dzZsW","fullLink":"style_fullLink__2kmOo","flag":"style_flag__TIgXs"};